module.exports = __webpack_public_path__ + "img/9788957983492.6e9045ef.jpg";